import React, { useEffect } from 'react'
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
// import {usePropertiesContext} from './context/PropertiesContext';

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap'
import '../src/assets/css/style.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import 'react-tabs/style/react-tabs.css'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

// Pages
import Error404 from './pages/Error404'
import Home from './pages/Home'
import HomeNew from './pages/HomeNew'
import FAQs from './pages/FAQs'
import ContactUs from './pages/ContactUs'
// import IndividualListing from './pages/IndividualListing'
import Why800Homes from './pages/Why800Homes'
import Leadership from './pages/Leadership'
import WhyDubai from './pages/WhyDubai'
import PrivacyPolicy from './pages/PrivacyPolicy'
import TermsAndConditions from './pages/TermsAndConditions'
import Careers from './pages/Careers'
// import Blogs from './pages/Blogs'
import BuyProperty from './pages/BuyProperty'
// import Blog from './pages/Blog'
import SellProperty from './pages/SellProperty'
import Events from './pages/Events'
import EventDetail from './pages/EventDetail'
import ThankYou from './pages/ThankYou'
import PropertyDetails from './pages/PropertyDetails'
import ProfileFaraazSiddiqui from './pages/ProfileFaraazSiddiqui'
import ProfileAanilMannwani from './pages/ProfileAanilMannwani'
import Profile800Homes from './pages/Profile800Homes'
// import ProfilePriyanka from './pages/ProfilePriyanka'
// import ProfileRiddhiBhagchandani from './pages/ProfileRiddhiBhagchandani'
import ProfileBhwnaManvani from './pages/ProfileBhwnaManvani'
import TeamPage from './pages/TeamPage'
import News from './pages/News'
import NewsDetail from './pages/NewsDetail'
import ReellyProperties from './pages/ReellyProperties'

// NEW IMPORTS
import Brochure from './pages/Brochure'
import Reports from './pages/Reports'

// import ProfileArsalanNadkar from './pages/ProfileArsalanNadkar'
import DubaiInvestment from './pages/DubaiInvestment'
import MohamedElnagr from './pages/MohamedElnagr'
// import AmalBenYoussef from './pages/AmalBenYoussef'
// import ManalMahri from './pages/ManalMahri'
import ZunairaTazkeerHussain from './pages/ZunairaTazkeerHussain'
import LakshayChoudhary from './pages/LakshayChoudhary'
import Uday from './pages/Uday'
import Yash from './pages/Yash'
import Anam from './pages/Anam'
import Anum from './pages/Anum'
import Rashmi from './pages/Rashmi'
import AjmalMusthafa from './pages/AjmalMusthafa'
import MohammadSalmanBadusha from './pages/MohammadSalmanBadusha'
import AwardsAndAchievements from './pages/AwardsAndAchievements'
import FrancisMari from './pages/FrancisMari'
import MortgageCalculator from './pages/MortgageCalculator'
import BrochureDetail from './pages/BrochureDetails'

const CanonicalMetadata = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const canonicalPath =
        location.pathname === '/' ? '/' : `${location.pathname.replace(/\/+$/, '')}/`
    const canonicalUrl = `https://800homes.ae${canonicalPath}`

    useEffect(() => {
        if (location.pathname !== canonicalPath) {
            navigate(
                {
                    pathname: canonicalPath,
                    search: location.search,
                    hash: location.hash,
                },
                { replace: true },
            )
        }
    }, [canonicalPath, location.hash, location.pathname, location.search, navigate])

    return (
        <Helmet>
            <link rel="canonical" href={canonicalUrl} />
            <meta property="og:url" content={canonicalUrl} />
        </Helmet>
    )
}

const App = () => {
    // const {properties} = usePropertiesContext();

    return (
        <>
            <CanonicalMetadata />
            <Routes>
                <Route path="*" element={<Error404 />} />

                <Route path="/thank-you" element={<ThankYou />} />

                <Route path="/faraaz-siddiqui" element={<ProfileFaraazSiddiqui />} />
                <Route path="/aanil-mannwani" element={<ProfileAanilMannwani />} />

                {/* <Route path="/priyanka-dev" element={<ProfilePriyanka />} /> */}
                {/* <Route path="/arsalan-nadkar" element={<ProfileArsalanNadkar />} /> */}
                {/* <Route path="/riddhi-bhagchandani" element={<ProfileRiddhiBhagchandani />} /> */}
                {/* <Route path="/khushi-rajpoot" element={<ProfileKhushiRajpoot />} /> */}

                <Route path="/bhwna-manvani" element={<ProfileBhwnaManvani />} />

                {/* <Route path="/riya-mehta" element={<ProfileRiya />} /> */}

                <Route path="/800-homes-real-estate-brokerage" element={<Profile800Homes />} />
                <Route path="/mohamed-elnagr" element={<MohamedElnagr />} />

                {/* <Route path="/amal-ben-youssef" element={<AmalBenYoussef />} /> */}
                {/* <Route path="/manal-mahri" element={<ManalMahri />} /> */}

                <Route path="/zunaira-tazkeer-hussain" element={<ZunairaTazkeerHussain />} />
                <Route path="/zunaira-hussain" element={<ZunairaTazkeerHussain />} />
                <Route path="/lakshay-choudhary" element={<LakshayChoudhary />} />

                <Route path="/uday" element={<Uday />} />
                <Route path="/yash" element={<Yash />} />
                <Route path="/anam" element={<Anam />} />
                <Route path="/anum" element={<Anum />} />
                <Route path="/rashmi" element={<Rashmi />} />
                <Route path="/ajmal-musthafa" element={<AjmalMusthafa />} />
                <Route path="/francis-mari" element={<FrancisMari />} />
                <Route path="/mohammad-salman-badusha" element={<MohammadSalmanBadusha />} />

                <Route path="/" element={<Home />} />
                <Route path="/home-new" element={<HomeNew />} />

                <Route path="/why-800-homes" element={<Why800Homes />} />
                <Route path="/awards-and-achievements" element={<AwardsAndAchievements />} />
                <Route path="/why-dubai" element={<WhyDubai />} />
                <Route path="/leadership/" element={<Leadership />} />
                <Route path="/our-team" element={<TeamPage />} />

                <Route path="/sell-property" element={<SellProperty />} />
                <Route path="/properties-for-sale" element={<BuyProperty />} />

                <Route path="/property/:slug" element={<PropertyDetails />} />

                <Route path="/careers" element={<Careers />} />
                <Route path="/faqs" element={<FAQs />} />

                {/* <Route path="/blogs" element={<Blogs />} /> */}
                {/* <Route path="/blog/:slug" element={<Blog />} /> */}

                <Route path="/projects" element={<ReellyProperties />} />

                <Route path="/news" element={<News />} />
                <Route path="/news/:slug" element={<NewsDetail />} />

                {/* NEW ROUTES */}

                <Route path="/brochures" element={<Brochure />} />
                <Route path="/brochure/:slug" element={<BrochureDetail />} />
                <Route path="/reports" element={<Reports />} />

                <Route path="/events" element={<Events />} />
                <Route path="/events/:slug" element={<EventDetail />} />

                <Route path="/dubai-property-investment" element={<DubaiInvestment />} />

                <Route path="/mortgage-calculator" element={<MortgageCalculator />} />

                <Route path="/contact-us" element={<ContactUs />} />

                <Route path="/privacy-policy" element={<PrivacyPolicy />} />

                <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            </Routes>

            <ToastContainer position="bottom-left" autoClose={5000} />
        </>
    )
}

export default App
